import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const MenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: var(--menu-bg, #111827);
  color: var(--menu-text, #9ca3af);
  font-family: 'Inter', sans-serif;
  overflow: hidden;
  width: 100%;
  transition: all 0.3s ease;
  position: relative;

  --menu-bg: #f5f5f5;
  --menu-text: #4b5563; /* Grey for Appointments, Campaigns, etc. */
  --menu-text-active: #ffffff; /* White for selected dropdown child */
  --menu-parent-active-text: #000000; /* Black for selected parent */
  --menu-accent: #007fb3;
  --menu-accent-bg: rgba(0, 127, 179, 0.15); /* Light shade of 007fb3 */
  --menu-group-title: #9ca3af; /* Light grey for Overview, Marketing, etc. */
  --menu-hover: rgba(0, 127, 179, 0.1);
  --menu-border: #e5e7eb;
`;

export const Header = styled.div`
  padding: ${props => props.collapsed ? '20px 0' : '20px 12px'};
  padding-bottom: ${props => props.collapsed ? '8px' : '16px'};
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: relative;
  align-items: ${props => props.collapsed ? 'center' : 'normal'};
`;

export const AppInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const LogoBox = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const AppDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`;

export const AppName = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 24px;
  
  img {
    height: 100%;
    width: auto;
    object-fit: contain;
    display: block;
  }
`;

export const AppRole = styled.div`
  margin-top: 2px;
  font-size: 12px;
  color: var(--menu-text);
  opacity: 0.7;
  display: ${props => props.collapsed ? 'none' : 'block'};
`;

export const BusinessBadge = styled.div`
  background: #ffffffff;
  border: 1px solid #00a88f;
  border-radius: 6px;
  padding: 6px 12px;
  display: ${props => props.collapsed ? 'none' : 'flex'};
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #000000ff;
`;

export const StatusDot = styled.div`
  width: 8px;
  height: 8px;
  background: #00d1b2;
  border-radius: 50%;
`;

export const ScrollArea = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0 12px 100px 12px;

  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #374151;
    border-radius: 10px;
  }

    @media (max-width: 1350px) and (min-width: 768px) {
    padding: 0 6px 100px 6px;
  }
`;

export const MenuGroup = styled.div`
  margin-top: 16px;
`;

export const GroupTitle = styled.div`
  padding: 0 12px;
  margin-bottom: 6px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--menu-group-title);
`;

export const MenuItem = styled.div`
  margin-bottom: 4px;
  font-size: 12px;
`;

export const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: ${props => props.collapsed ? 'center' : 'flex-start'};
  padding: 6px 12px;
  border-radius: 8px;
  color: ${props => props.active ? 'var(--menu-text-active)' : 'var(--menu-text)'};
  background: ${props => props.active ? 'var(--menu-accent)' : 'transparent'};
  transition: all 0.2s ease;
  text-decoration: none;
  font-size: 12px;
  font-weight: ${props => props.active ? '600' : '500'};
  position: relative;

  &:hover {
    background: var(--menu-accent);
    color: var(--menu-text-active);
  }

  .icon-wrap {
    width: 24px;
    display: flex;
    justify-content: center;
    margin-right: ${props => props.collapsed ? '0' : '12px'};
    font-size: 18px;
    color: inherit;
  }

  &:hover .icon-wrap {
    color: var(--menu-text-active);
  }

  @media (max-width: 1350px) and (min-width: 768px) {
    padding: 3px 6px;
    font-size: 12px;
    display: flex;
    align-items: center;

    .icon-wrap {
      font-size: ${props => props.collapsed ? '16px' : '14px'};
    }
  }
`;

export const DropdownTrigger = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${props => props.collapsed ? 'center' : 'flex-start'};
  padding: 6px 12px;
  border-radius: 8px;
  color: ${props => props.active ? 'var(--menu-parent-active-text)' : 'var(--menu-text)'};
  background: ${props => props.active ? 'var(--menu-accent-bg)' : 'transparent'};
  transition: all 0.2s ease;
  cursor: pointer;
  font-size: ${props => props.collapsed ? '16px' : '12px'};
  font-weight: ${props => props.active ? '600' : '500'};

  &:hover {
    background: var(--menu-accent-bg);
    color: var(--menu-parent-active-text);
  }

  .icon-wrap {
    width: 24px;
    display: flex;
    margin-right: ${props => props.collapsed ? '0' : '12px'};
    font-size: 18px;
  }

  .arrow {
    margin-left: auto;
    font-size: 12px;
    opacity: 0.5;
    display: ${props => props.collapsed ? 'none' : 'block'};
  }

  @media (max-width: 1350px) and (min-width: 768px) {
    padding: 3px 6px;
    font-size: 12px;

    .icon-wrap {
      font-size: ${props => props.collapsed ? '16px' : '12px'};
    }
  }
`;

export const SubMenu = styled.ul`
  list-style: none;
  padding: ${props => props.collapsed ? '4px 0' : '4px 0 4px 36px'};
  margin: 0;
`;

export const SubMenuItem = styled.li`
  margin-bottom: 2px;
  font-size-: 12px;
`;

export const SubLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: ${props => props.collapsed ? 'center' : 'flex-start'};
  padding: 6px 12px;
  border-radius: 6px;
  color: ${props => props.active ? 'var(--menu-text-active)' : 'var(--menu-text)'};
  background: ${props => props.active ? 'var(--menu-accent)' : 'transparent'};
  font-size: 12px;
  text-decoration: none;
  transition: all 0.2s ease;

  &:hover {
    color: var(--menu-text-active);
    background: var(--menu-accent);
    
    i, .icon {
      color: var(--menu-text-active) !important;
      opacity: 1 !important;
    }
  }

  i, .icon {
    color: ${props => props.active ? 'var(--menu-text-active)' : 'inherit'};
    opacity: ${props => props.active ? '1' : '0.6'} !important;
    transition: all 0.2s ease;
    margin-right: ${props => props.collapsed ? '0' : '8px'};
  }
`;

export const Badge = styled.span`
  background: ${props => props.type === 'new' ? 'var(--menu-accent)' : '#ef4444'};
  color: white;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 10px;
  margin-left: auto;
  font-weight: 700;
  display: ${props => props.collapsed ? 'none' : 'block'};
`;

export const CollapseButton = styled.div`
  top: 10px;
  right: ${props => props.collapsed ? 'auto' : '10px'};
  cursor: pointer;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  background: var(--menu-accent-bg);
  color: var(--menu-accent);
  transition: all 0.2s ease;
  z-index: 100;

  &:hover {
    background: var(--menu-accent);
    color: white;
  }
`;
